import gsap from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { Maths } from '../_app/cuchillo/utils/Maths';

import Default from './Default';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';
import CircleVisor from '../layout/CircleVisor';

export default class Contact extends Default {
   
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();

    this._isAux = GetBy.class("__aux", this.container)[0];

    
    
    if(this._isAux) {
      this.setupAnimation();
      CircleVisor.addCabezales([...GetBy.class("__team", this.container)]);
    } else {
      this.setupAnimation2();
    }
  }

  setupAnimation() {
    let delay = 0;
    let cont = 0;
    let index = 0;
    this.timeline = gsap.timeline({ paused: true });
    [...GetBy.class("__ani")].map(project => {
      console.log(project)
      this.timeline.from(project, {
        alpha: 0,
        duration: .4,
        force3D: true
      }, delay);
      //delay += .02;
      delay += .21;

      
    });
  }

  setupAnimation2() {
    this.projects = [...GetBy.class('__line')];
    this.timeline = gsap.timeline({ paused: true });
    let delay = 0;
    let cont = 0;
    let index = 0;

    this.projects.map(project => {
      this.timeline.from(project, {
        alpha: 0,
        duration: .1,
        force3D: true
      }, delay);
      delay += Math.max(.02, .02 - .01 * cont);

      //delay += .02;
      index++;
      cont += Math.min(1, .5 * index * index);
    });
  }

  show__effect(__call) {
    
    if(this._isAux) {
      CircleVisor.goContact();
    }
   

    if (this.isFirstTime) {
      Wrap.directShow();
      Preloader.hide(() => { 
        this.timeline.restart();
        this.afterShow();
      });
    } else {
      if(this._isAux) {
      Wrap.show(null,{delay:.5});
      } else {
        Wrap.directShow();
      }
      this.timeline.restart();
      this.afterShow();
    }
  }

  hide__effect() {
    if(this._isAux) {
      CircleVisor.hide();
    }
    super.hide__effect();
  }
  
  beforeShow() {
    super.beforeShow();
  }

  afterHide() {
    if(this._isAux) {
      CircleVisor.disposeCabezales();
    }
    super.afterHide();
  }

  loop() {
   
  }

  resize() {
    super.resize();
  }
}

ControllerPage._addPage("page-contact", Contact)
